
const maintainYear = {
    header: "Hospital Master",
    gridColumn: {
        maintainyear: {
            field: "maintyearvalue",
            header: "Year",
        },
        startdate: {
            field: "startdate",
            header: "Start Date",
        },
        enddate: {
            field: "enddate",
            header: "End Date",
        },
        weekvalue: {
            field: "weekvalue",
            header: "No. of Weeks",
        },
    },
    exportfile: {
        name: 'MaintenanceYear',
        sheetName: 'maintenanceYear'
    }
}
const standardtask = {
    header: "Hospital Master",
    gridColumnWorkgroups: {
       wgcode:{
        field: "wgcode",
        header: "Work Group Code",
       },
       wgdesc:{
        field: "wgdesc",
        header: "Work Group Description",
       },
        nooftasks: {
            field: "nooftasks",
            header: "No. of Tasks",
        },
        action: {
            field: "actions",
            header: "Actions",
        },
        taskcode: {
            field: "taskcode",
            header: "Task Code",
        },
        taskdesc: {
            field: "taskdesc",
            header: "Task Description",
        },
        workinstructions: {
            field: "workinstructions",
            header: "Work Instructions",
        },
        status: {
            field: "isactiveformate",
            header: "Status",
        },
        effectivefrom: {
            field: "effectivefrom",
            header: "Effective From",
        },

    },
    exportfile: {
        fileName: 'StandardTasks',
        sheetName: 'standardTasks'
    }

}
const assetcondition = {
    header: "Hospital Masters",
    gridColumn: {
        assetno: {
            field: "assetName",
            header: "Assset No",
        },
        assetdesc: {
            field: "assetDescription",
            header: "Asset Description",
        },
        typecode: {
            field: "typecode",
            header: "Type Code",
        },
        typecodedesc: {
            field: "typeDescription",
            header: "Type Code Description",
        },
        date: {
            field: "date",
            header: "Date",
        },
        equipmentcondition: {
            field: "equipmentcondition",
            header: "Equipment Condition",
        },
        updatedby: {
            field: "updatedby",
            header: "Updated By",
        }

    },
    exportfile: {
        name: 'AssetCondition',
        sheetName: 'assetCondition'
    }
}

const staffdetails = {
    gridColumn:{
        employeeId:{
            field:'empCode',
            header:'Staff ID'
        },
        employeeName:{
            field:'empName',
            header:'Staff Name'
        },
        designation:{
            field:'designation',
            header:'Designation'
        },
        status: {
            field: "isactive",
            header: "Status",
        },
        effectivefrom: {
            field: "effectivefrom",
            header: "Effective From",
        },
        service: {
            field: "service",
            header: "Service",
        },
        skillslevel:{
            field:'skillLevel',
            header:'Skills Level'
        },
        location: {
            field: "location",
            header: "Location",
        }
    },
    exportfile: {
        name: 'Staff Details',
        sheetname: 'staff Details'
    }
}
const contractregister = {
    header: "Contract Register",
    gridColumn:{
        serviceDesc: {
            field: "serviceDesc",
            header: "Service",
        },
        contractno: {
            field: "contractno",
            header: "Contract No",
        },
        vendorname: {
            field: "vendorname",
            header: "Vendor Name"
        },
        vendorcode: {
            field: "vendorcode",
            header: "Vendor Code"
        },
        contracttype:{
            field: "contracttype",
            header: "Contract Type"
        },
        rating:{
            field: "rating",
            header: "Rating"
        },
        status: {
            field: "isactive",
            header: "Status",
        },
    },
    exportfile: {
        fileName: 'ContractRegister',
        sheetName: 'contractregister'
    }
}

const history ={
    header: "Contract Register History",
    gridColumn:{
        oldContractno: {
            field: "oldContractno",
            header: "Old Contract No",
        },
        newContractno: {
            field: "newContractno",
            header: "New Contract No",
         },
         flag: {
            field: "flag",
            header: "Flag",
         },
         pic: {
            field: "pic",
            header: "PIC",
         },
         status: {
            field: "status",
            header: "Status",
         },
         remarks: {
            field: "remarks",
            header: "Remarks",
         },
         attachment: {
            field: "attachment",
            header: "Attachment",
         },

    },
    exportfile: {
        fileName: 'history',
        sheetName: 'history'
    }
}

const vendordetails ={
    gridColumn:{
        vendorcode:{
            field:'vendorCode',
            header:'Vendor Code'
        },
        vendorname:{
            field:'vendorName',
            header:'Vendor Name'
        },
        status: {
            field: "status",
            header: "Status",
        },
        companytype: {
            field: "companyType",
            header: "Type of Company",
        },
        category:{
            field:'category',
            header:'Category'
        },
        group:{
            field:'group',
            header:'Group'
        },
        service:{
            field:'service',
            header:'Service'
        }
       
    },
    exportfile: {
        name: 'VendorDetails',
        sheetName: 'vendorDetails'
    }
}
export {
    maintainYear,
    standardtask,
    assetcondition,
    staffdetails,
    vendordetails,
    contractregister,
    history
}